//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations, mapGetters } from "vuex";

export default {
    name: "QfPIndex",
    data() {
        return {
            localValue: null,
            max: 1,
            parent: null,
            disabled: false
        };
    },
    computed: {
        ...mapState("components", ["bodyReference", "properties", "activeComponent"]),
        ...mapGetters("components", ["body"])
    },
    watch: {
        activeComponent: {
            handler(val) {
                this.updateValues(val);
            },
            immediate: true
        },
        body: {
            handler() {
                if (this.activeComponent) {
                    this.updateValues(this.activeComponent);
                }
            },
            deep: true
        }
    },

    methods: {
        ...mapMutations("components", ["updateChildPosition"]),
        updateValues(activeComponent) {
            this.parent = this.properties[activeComponent].parent || "body";
            const childList = this.bodyReference[this.parent];
            this.localValue = childList.findIndex(({ guid }) => guid === activeComponent) + 1;

            if (childList.length === 1) {
                this.max = 2;
                this.disabled = true;
            } else {
                this.max = childList.length;
                this.disabled = false;
            }
        },
        change(val) {
            if (val !== this.localValue) {
                this.updateChildPosition({ parent: this.parent, newIndex: val - 1, oldIndex: this.localValue - 1 });
                this.localValue = val;
                this.$root.$emit("showCheckedSaveBtn", false);
            }
        }
    }
};
